import { clamp } from '@/helpers/range'
import color from '@/helpers/color'

const fontSizeS = getComputedStyle(document.documentElement).getPropertyValue('--text--s')
const fontSizeM = getComputedStyle(document.documentElement).getPropertyValue('--text--m')
// const fontSizeXS = getComputedStyle(document.documentElement).getPropertyValue('--text--xs')
const fontFamily = getComputedStyle(document.documentElement).getPropertyValue('--font--base')

export const FontStyle = {
  VALUE: `${fontSizeM} ${fontFamily}`,
  EXP: `${fontSizeS} ${fontFamily}`
}

export const InterpolationMode = {
  LINEAR: 'linear',
  QUADRATIC: 'quadratic',
  CUBIC: 'cubic'
}

const colorSoil = getComputedStyle(document.documentElement).getPropertyValue('--color--soil--base')
const colorWhite = getComputedStyle(document.documentElement).getPropertyValue('--color--white')
const colorNitrate = getComputedStyle(document.documentElement).getPropertyValue('--color--soil--n')
const colorRoot = getComputedStyle(document.documentElement).getPropertyValue('--color--soil--root')
const colorPrimary = getComputedStyle(document.documentElement).getPropertyValue('--color--primary')
const colorSecondary = getComputedStyle(document.documentElement).getPropertyValue('--color--secondary')
const colorOutlines = getComputedStyle(document.documentElement).getPropertyValue('--color--outlines')
const colorRain = getComputedStyle(document.documentElement).getPropertyValue('--color--rain--2')

const colorRainObject = color.parse(colorRain.trim())
const colorNitrateObject = color.parse(colorNitrate.trim())

export const Color = {
  BONE: 'rgba(255, 0, 255, 0.5)',
  BONE_CURRENT: 'rgba(0, 255, 255, 0.5)',
  PRIMARY: colorPrimary,
  SECONDARY: colorSecondary,
  OUTLINES: colorOutlines,
  ROOTS: colorRoot,
  SOIL: colorSoil,
  WHITE: colorWhite,
  RAIN: (rain) => {
    colorRainObject[3] = clamp(rain, 0, 1)
    return color.stringify(colorRainObject, 'rgba')
  },
  NITRATE: (nitrate) => {
    colorNitrateObject[3] = clamp(nitrate, 0, 1)
    return color.stringify(colorNitrateObject, 'rgba')
  }
}

export const Soil = {
  HEIGHT: 0.40,
  MARGIN: 88
}

export const NitrateParticle = {
  COUNT: 200,
  RADIUS: 2
}

export const RainDrop = {
  COUNT: 200
}

export const RainDropParticle = {
  ALPHAMIN: 0.2,
  ALPHAMAX: 0.3
}

export const Root = {
  WIDTH: 5
}

export default {
  InterpolationMode,
  Color,
  Soil,
  NitrateParticle,
  RainDrop,
  RainDropParticle,
  Root
}
